import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'

export { default as Slider } from './Slider.vue'

export const sliderVariants = cva('relative flex touch-none select-none items-center gap-3', {
  variants: {
    type: {
      basic: '',
    },
    size: {
      xs: '',
    },
    direction: {
      horizontal: '',
      vertical: 'flex-col',
    },
  },
  compoundVariants: [
    {
      direction: 'horizontal',
      size: 'xs',
      class: 'w-64',
    },
    {
      direction: 'vertical',
      size: 'xs',
      class: 'h-64',
    },
  ],
  defaultVariants: {
    type: 'basic',
    size: 'xs',
    direction: 'horizontal',
  },
})

export const sliderTrackVariants = cva('relative grow overflow-hidden bg-glass60 rounded-8xl', {
  variants: {
    direction: {
      horizontal: 'h-2 w-full',
      vertical: 'w-2 h-full',
    },
  },
  defaultVariants: {
    direction: 'horizontal',
  },
})

export const sliderRangeVariants = cva(
  'absolute bg-white rounded-8xl data-[disabled]:bg-text-disabled',
  {
    variants: {
      direction: {
        horizontal: 'h-full',
        vertical: 'w-full',
      },
    },
    defaultVariants: {
      direction: 'horizontal',
    },
  },
)

export const sliderThumbVariants = cva(
  'block h-3 w-3 rounded-full cursor-pointer bg-brand-blue1 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-blue1 focus-visible:ring-offset-2 data-[disabled]:cursor-not-allowed',
)

export type SliderVariants = VariantProps<typeof sliderVariants>
